import firebase from 'firebase';
import { AppDispatch } from '../../store';
import { COLLECTIONS } from '../../constants/data';
import { menuUpdated, menuListenerError, resetMenu } from './menu.slice';
import { serializeMenuSnap } from './menu.service';

let unsubscribeMenu: firebase.Unsubscribe | null = null;
let activeMenuKey: string | null = null;

export const syncMenuListener = (
  restaurantId: string | null,
  menuId: string | null,
  dispatch: AppDispatch
) => {
  const key = restaurantId && menuId ? `${restaurantId}::${menuId}` : null;
  if (key === activeMenuKey) return;

  if (unsubscribeMenu) { unsubscribeMenu(); unsubscribeMenu = null; }

  activeMenuKey = key;

  if (!key || !restaurantId || !menuId) {
    dispatch(resetMenu());
    return;
  }

  unsubscribeMenu = firebase.firestore()
    .collection(COLLECTIONS.restaurants).doc(restaurantId)
    .collection(COLLECTIONS.menu).doc(menuId)
    .onSnapshot(
      (snapshot) => {
        if (!snapshot.exists) return;
        dispatch(menuUpdated(serializeMenuSnap(snapshot)));
      },
      (error) => {
        dispatch(menuListenerError(error.message));
        activeMenuKey = null;
        unsubscribeMenu = null;
      }
    );
};